import React from 'react';
import './TurnIndicator.css';

interface TurnIndicatorProps {
  isMyTurn: boolean;
  currentPlayerName?: string;
  timeLeft?: number;
}

export const TurnIndicator: React.FC<TurnIndicatorProps> = ({
  isMyTurn,
  currentPlayerName,
  timeLeft
}) => {
  // Determine urgency level based on time remaining
  const getUrgencyClass = () => {
    if (timeLeft === undefined || timeLeft === null) return '';
    if (timeLeft <= 3) return 'urgency-critical';
    if (timeLeft <= 5) return 'urgency-high';
    if (timeLeft <= 10) return 'urgency-medium';
    return '';
  };

  const urgencyClass = getUrgencyClass();

  if (isMyTurn) {
    return (
      <div className={`turn-indicator your-turn ${urgencyClass}`}>
        <div className="turn-indicator-content">
          <span className="turn-icon">👉</span>
          <span className="turn-text">Your Turn!</span>
          {timeLeft !== undefined && timeLeft > 0 && (
            <span className={`turn-timer ${urgencyClass}`}>{timeLeft}s</span>
          )}
        </div>
      </div>
    );
  }

  if (currentPlayerName) {
    return (
      <div className={`turn-indicator other-turn ${urgencyClass}`}>
        <div className="turn-indicator-content">
          <span className="turn-icon">⏳</span>
          <span className="turn-text">{currentPlayerName}'s turn</span>
          {timeLeft !== undefined && timeLeft > 0 && (
            <span className={`turn-timer ${urgencyClass}`}>{timeLeft}s</span>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default TurnIndicator;
